import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { SiteAction, AlertAction, AuthAction, SiteSurveyAction, InstallationAction } from '../../actions';
import { RayDelButton } from '../common/Buttons';
import { Translate as t } from '../../config/Translate';
import { formatDisplayDate } from '../../lib/dateDisplay';

const fmtDate = (v) => formatDisplayDate(v);

const IntallationCard = ({ item, DeleteInstallation }) => {

	const [view, setView] = useState(false);
	// const [ t, i18n ] = useTranslation();
	const del = () => {
		DeleteInstallation(item._id);
	}

	return (
		<div className="accordion round-box progress-card mb-1">
			<div className="accordion-item">
				<h2 className="accordion-header">
					<button className="accordion-button collapsed" onClick={() => setView(!view)} style={{ width: "100%" }}>
						<div className="item">
							{!item.isSubmit && <div className="in">
								<div>
									<div className="d-flex align-items-baseline" style={{ gap: '0.5rem', flexWrap: 'wrap' }}>
										{item.site?.sitename && <h4 className="mb-0">{item.site?.sitename}</h4>}
										<small className="text-muted" style={{ fontSize: '0.8rem' }}>
											<strong>{t('common.label.createDate')}</strong>: {fmtDate(item.createDate)} <span aria-hidden="true">·</span> <strong>{t('installation.field.installationDate')}</strong>: {fmtDate(item.installationDate)}
										</small>
									</div>
									{item.product && <p>{item.product.model} {item.product.option && "/ " + item.product.option}</p>}
								</div>
								<div className="price">{item.installationStep} / 8</div>
							</div>}
							{!item.isSubmit && <div className="progress mt-1">
								<div className="progress-bar bg-success" style={{ width: ((item.installationStep / 8) * 100) + "%" }}>{Math.round((item.installationStep / 8) * 100) + "%"}</div>
							</div>}
							{item.isSubmit && <div>
								<ion-icon name="checkmark-circle" size="large" class="text-success fl md hydrated"></ion-icon>
								<div className="d-flex align-items-baseline" style={{ gap: '0.5rem', flexWrap: 'wrap' }}>
									{item.site?.sitename && <h4 className="mb-0">{item.site?.sitename}</h4>}
									<small className="text-muted" style={{ fontSize: '0.8rem' }}>
										<strong>{t('common.label.createDate')}</strong>: {fmtDate(item.createDate)} · <strong>{t('installation.field.installationDate')}</strong>: {fmtDate(item.installationDate)}
									</small>
								</div>
								{item.product && <p>{item.product.model} {item.product.option && "/ " + item.product.option}</p>}
							</div>}
						</div>
					</button>
				</h2>
				{view && <div className="accordion-collapse">
					<div className="accordion-body mt-0">
						{!item.isSubmit && <Link to={"/Installation/" + item._id} className="btn btn-block btn-primary">{t('common.button.edit')}</Link>}
						{item.isSubmit && <Link to={"/Installation/" + item._id + "/view"} className="btn btn-block btn-primary">{t('common.button.view')}</Link>}
						{!item.isSubmit && <RayDelButton css="btn btn-block btn-dark" callback={() => del()} startMsg={t('common.button.delete')} />}
					</div>
				</div>}
			</div>
		</div>
	)
};

const mapDispatch = dispatch => ({
	DeleteInstallation: (_id) => dispatch(InstallationAction.DeleteInstallation(_id)),
})

export default connect(null, mapDispatch)(IntallationCard);